import React from "react";
import { FieldProps } from "@rjsf/core";
import { IOAuthAccount } from "../../models/IOAuthAccount";
import { MessageBar, MessageBarType } from "@fluentui/react";

export const BasicAuthNoticeField: React.FC<FieldProps<IOAuthAccount>> = () => {
  return (
    <MessageBar messageBarType={MessageBarType.severeWarning} isMultiline={true} className="rca-Custom-field">
      {ClientStrings.BasicAuthTestNotice}
    </MessageBar>
  );
};
